import { useLazyQuery } from "@apollo/client"
import FormsLists from "./forms/lists/FormsLists"
import { GET_FORM_CONTENT, GET_TEMPLATE_CONTENT } from "../graphql/queries"
import { IGetTemplateContentOutput, IGetTemplateContentInput, IGetFormContentOutput, IGetFormContentInput } from "../graphql/types/queries/forms"
import { useState } from "react"
import { IFormMeta } from "./forms/builder/Builder"
import { IProperties } from "./forms/builder/types"
import Modal from "styled-react-modal"
import { SpecialModalBackground } from "../components/Commons"
import { Box, Flex } from "rebass/styled-components"
import styled from "styled-components"
import { PreviewHcForm } from "./forms/builder/Preview"
import PleaseWait from "../components/PleaseWait"


const Wrapper = styled(Flex)`
  overflow: auto;
  width: 800px;
  padding-right: 20px;
  margin-right: 20px;
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #6c89b7;
    border-radius: 5px;
  }
  &::-webkit-scrollbar {
    width: 7px;
    border: 1px solid transparent;
  }
`;
const FormListing = () => {
  const [preview, setPreview] = useState<{
    meta: IFormMeta,
    content: Array<IProperties>
  } | null>(null)
  const [getTemplateContent, { data: dataTemplateContent, loading: loadingTemplateContent, error: errorTemplateContent }] = useLazyQuery<IGetTemplateContentOutput, IGetTemplateContentInput>(GET_TEMPLATE_CONTENT, {
    onCompleted: (e) => {
      setPreview({
        meta: {
          id: e.getTemplateContent.id,
          name: e.getTemplateContent.name,
          target: e.getTemplateContent.target.id,
          targetName: e.getTemplateContent.target.target,
          version: e.getTemplateContent.version,
          description: e.getTemplateContent.description,
          basedOnTemplate: e.getTemplateContent.id
        },
        content: JSON.parse(e.getTemplateContent.content)
      })
    }
  })
  const [getFormContent, { data: dataFormContent, loading: loadingFormContent, error: errorFormContent }] = useLazyQuery<IGetFormContentOutput, IGetFormContentInput>(GET_FORM_CONTENT, {
    onCompleted: (e) => {
      setPreview({
        meta: {
          id: e.getFormContent.id,
          name: e.getFormContent.name,
          target: e.getFormContent.target.id,
          targetName: e.getFormContent.target.target,
          version: e.getFormContent.version,
          description: e.getFormContent.description,
          basedOnTemplate: e.getFormContent.basedOnTemplate?.id || ''
        },
        content: JSON.parse(e.getFormContent.content)
      })
    }
  })

  return (
    <>
      <FormsLists
        onPreviewTemplate={(id) => {
          getTemplateContent({
            variables: {
              templateId: id
            }
          })
        }}
        onPreviewForm={(id) => {
          getFormContent({
            variables: {
              formId: id
            }
          })
        }} />
      {(!!preview || !!loadingFormContent || !!loadingFormContent) && (
        <Modal
          isOpen={true}
          onBackgroundClick={() => {
            setPreview(null);
          }}
          onEscapeKeydown={() => {
            setPreview(null);
          }}
        >
          <SpecialModalBackground
            onClick={() => {
              setPreview(null);
            }}
          >
            <Box
              style={{
                margin: '0 auto',
                alignSelf: 'center',
                borderRadius: '20px',
                position: 'relative',
                background: 'linear-gradient(180deg, #BBD4ED 0%, #FDF5F2 100%)',
                padding: '24px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                maxWidth: '95vw',
                minWidth: 'initial',
                maxHeight: '95vh',
                minHeight: '95vh',
                overflowY: 'hidden',
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            >
              <Wrapper flex={1} flexDirection={'column'} width={'800px'} style={{ overflowY: 'auto' }}>
                {!!loadingFormContent || !!loadingTemplateContent || !preview ? (
                  <PleaseWait />
                ) : (
                  <PreviewHcForm tree={preview.content} meta={preview.meta} close={() => setPreview(null)} />
                )}
              </Wrapper>
            </Box>
          </SpecialModalBackground>
        </Modal>
      )}
    </>
  )
}

export default FormListing